interface LoadingProps {
  label?: string
}

export default function Loading({
  label = "불러오는 중",
}: Readonly<LoadingProps>) {
  return (
    <div
      role="status"
      aria-live="polite"
      className="flex items-center justify-center gap-2 py-12"
    >
      <span
        aria-hidden="true"
        className="size-5 animate-spin rounded-full border-2 border-app-secondary-500 border-t-app-primary-500"
      />
      <span className="app-txt-body2 text-app-text-300">{label}</span>
    </div>
  )
}
